"use client";

import { useState } from "react";
import { motion } from "motion/react";

export default function FAQ({ question, children, first, last }) {
    const [open, setOpen] = useState(false);

    const variants = {
        open: { rotate: 135 },
        closed: { rotate: 0 },
    };

    const contentVariants = {
        open: {
            opacity: 1,
            height: "auto",
            overflow: "visible",
        },
        closed: { opacity: 0, height: 0, overflow: "hidden" },
    };

    return (
        <div>
            <div
                className={`flex items-center justify-between cursor-pointer ${
                    !first && "pt-5"
                } ${!last && "pb-5"}`}
                onClick={() => setOpen(!open)}
            >
                <h3 className="text-lg dark:text-white font-bold font-sourceSans">
                    {question}
                </h3>
                <motion.div
                    initial={false}
                    animate={open ? "open" : "closed"}
                    variants={variants}
                    className="dark:text-lightBlue"
                    transition={{ duration: 0.2 }} // Durée de l'animation de la croix
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                    >
                        <path
                            fill="none"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="4"
                            d="M12 4v16m8-8H4"
                            color="currentColor"
                        ></path>
                    </svg>
                </motion.div>
            </div>
            <motion.div
                initial={false}
                animate={open ? "open" : "closed"}
                variants={contentVariants}
                transition={{ duration: 0.3, ease: "easeInOut" }} // Durée de l'animation des enfants
            >
                <div
                    className={`pb-5 leading-7 font-light flex flex-col gap-3 dark:text-lightBlue ${
                        last && "pt-5"
                    }`}
                >
                    {children}
                </div>
            </motion.div>
        </div>
    );
}
